import React from "react";

import BaseAdmin from "./BaseAdmin"
import {API, Auth} from "aws-amplify";
import {Button, Card, Checkbox, Col, Form, Input, InputNumber, message, Row, Select, Spin, Typography} from "antd";
import {CustomSpinner} from "../../Components/Spin/CustomSpiner";
import definitions from "../../Util/AFIPdefinitions";
import {withBreakpoints} from "react-breakpoints";
import {connect} from "react-redux";
import {allDispatch as mapDispatchToProps, allState as mapStateToProps} from "../../Redux/Selectors";
import {withRouter} from "react-router-dom";

const {Option} = Select;
const {TextArea} = Input;
const {Text} = Typography;
var interval = null
var count = 0

class EditUserLite extends React.Component {

    constructor(props) {
        super(props);
        this.id = this.props.match.params.id;
        this.state = {
            loading: true,
            formData: {
                razon_social: '',
                cuit: null,
                telefono: null,
                email: null,
                id_impositivo: null,
                domicilio_cliente: null,
                localidad: null,
                provinicia: null,
                active_signup: false,
                code_active: null,
                is_code_active: false,
                display_name: null
            }
        };
    }


    save = () => {
        this.props.form.validateFieldsAndScroll({first: true}, (err, values) => {
            if (!err) {
                this.setState({loading: true});
                const body = {...this.state.formData}

                if(!body.code_active) {
                    body.code_active = "NONE";
                }
                Promise.all([
                    Auth.currentSession(),
                    Auth.currentUserInfo()
                ]).then(([response, user]) => {
                    API.put(
                        'test',
                        '/root/admindashboard/',
                        {
                            headers: {
                                Authorization: response.getIdToken().getJwtToken()
                            },
                            body: body
                        }
                    )
                        .then(response => {
                            message.success("Guardado con exito")
                            this.props.history.goBack();
                        })
                        .catch(err => {
                            message.error("Error al guardar");
                            this.setState({loading: false});
                            console.log(err)
                        })
                });
            }
        });

    }

    componentDidMount() {
        this.setState({loading: true})
        Promise.all([
            Auth.currentSession(),
            Auth.currentUserInfo()
        ]).then(([response, user]) => {
            API.get(
                'test',
                '/root/admindashboard/' + this.id,
                {
                    headers: {
                        Authorization: response.getIdToken().getJwtToken()
                    }
                }
            )
                .then(response => {
                    if(response && response.code_active === 'NONE'){
                        response.code_active = '';
                    }
                    this.setState({loading: false, formData: response})
                })
                .catch(err => console.log(err))
        });
    }

    updateData(fields, values) {
        const new_data = {...this.state.formData}
        for (var i = 0; i < fields.length; i++) {
            new_data[fields[i]] = values[i]
        }
        this.setState({formData: new_data})
    }

    render() {

        if (this.state.loading) {
            return (
                <BaseAdmin
                    title="Editar admin lite"
                    selected="edit-user-admin-lite"
                >
                    <Row type="flex" justify="space-around" align="middle">
                        <Col style={{minHeight: '360px'}}>
                            <Spin indicator={CustomSpinner}/>
                        </Col>
                    </Row>
                </BaseAdmin>)
        } else {

            let documentos_cf = definitions.documento.filter(doc => doc.value !== 80)
            const {breakpoints, currentBreakpoint} = this.props;
            const {currentStep} = this.state;
            const {getFieldDecorator, getFieldValue, resetFields} = this.props.form;
            const defaultitem = [{
                key: this.state.currentKey + 1,
                codigo: 1,
                concepto: "",
                unidad: 7,
                cantidad: null,
                precio: null
            }];

            const breakpoint = (br) => {
                return breakpoints[currentBreakpoint] >= breakpoints[br]
            }

            const steps = [
                {
                    title: 'Datos',
                    content:
                        <>
                            <Row gutter={10}>
                                <Col lg={8}>
                                    <Form.Item label="CUIT">
                                        {
                                            getFieldDecorator('numero-documento-cliente', {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: 'Dato requerido'
                                                    }
                                                ],
                                                value: this.state.formData.cuit,
                                                initialValue: this.state.formData.cuit,
                                                validateFirst: true
                                            })(
                                                <Input
                                                    disabled={true}
                                                    style={{width: '100%'}}
                                                    onChange={(value) => this.updateData(["cuit"], [value ? value : null])}
                                                />
                                            )
                                        }
                                    </Form.Item>
                                </Col>
                                <Col lg={8}>
                                    <Form.Item label="Razon Social">
                                        {
                                            getFieldDecorator('razon', {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: 'Dato requerido'
                                                    }
                                                ],

                                                value: this.state.formData.razon_social,
                                                initialValue: this.state.formData.razon_social,
                                                validateFirst: true
                                            })(
                                                <Input

                                                    style={{width: '100%'}}
                                                    onChange={(value) => this.updateData(["razon_social"], [value ? value : null])}
                                                />
                                            )
                                        }
                                    </Form.Item>
                                </Col>
                                <Col lg={8}>
                                    <Form.Item label="Email">
                                        {
                                            getFieldDecorator('email-cliente', {
                                                value: this.state.formData.email,
                                                initialValue: this.state.formData.email,
                                                rules: [
                                                    {
                                                        type: 'email',
                                                        message: 'Email válido requerido',
                                                    },
                                                    {
                                                        required: true,
                                                        message: 'Dato requerido'
                                                    }
                                                ]
                                            })(
                                                <Input
                                                    onChange={(e) => this.updateData(["email"], [e.target.value ? e.target.value : null])}

                                                />)
                                        }
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={10}>
                                <Col lg={8}>
                                    <Form.Item label="Condición IVA">
                                        {
                                            getFieldDecorator('responsable', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Dato requerido'
                                                }],
                                                value: this.state.formData.id_impositivo,
                                                initialValue: this.state.formData.id_impositivo,
                                            })(
                                                <Select

                                                    onChange={(value) => {
                                                        if (value === "consumidor-final") {
                                                            this.updateData(["id_impositivo"], ["consumidor-final"])
                                                        } else {
                                                            this.updateData(["id_impositivo"], [value])
                                                        }
                                                    }}
                                                >
                                                    {
                                                        definitions.responsable.map(value => {
                                                            return (<Option key={value.value}
                                                                            value={value.value}>{value.name}</Option>)
                                                        })
                                                    }
                                                </Select>
                                            )
                                        }
                                    </Form.Item>

                                </Col>
                                <Col lg={8}>
                                    <Form.Item label="Domicilio">
                                        {
                                            getFieldDecorator('domicilio_cliente', {
                                                value: this.state.formData.domicilio_cliente,
                                                initialValue: this.state.formData.domicilio_cliente,
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: "Domicilio requerido"
                                                    }
                                                ]
                                            })(
                                                <Input

                                                    onChange={(e) => this.updateData(["domicilio_cliente"], [e.target.value ? e.target.value : null])}
                                                />
                                            )
                                        }
                                    </Form.Item>
                                </Col>
                                <Col lg={8}>
                                    <Form.Item label="Localidad">
                                        {
                                            getFieldDecorator('localidad', {
                                                value: this.state.formData.localidad,
                                                initialValue: this.state.formData.localidad,
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: "Localidad requerida"
                                                    }
                                                ]
                                            })(
                                                <Input

                                                    onChange={(e) => this.updateData(["localidad"], [e.target.value ? e.target.value : null])}
                                                />
                                            )
                                        }
                                    </Form.Item>
                                </Col>

                            </Row>
                            <Row gutter={10}>
                                <Col lg={8}>
                                    <Form.Item label="Provincia">
                                        {
                                            getFieldDecorator('provincia', {
                                                rules: [{
                                                    required: true,
                                                    message: "Provincia requerida"
                                                }],
                                                value: this.state.formData.provincia,
                                                initialValue: this.state.formData.provincia,
                                            })(
                                                <Select

                                                    onChange={(value) => {
                                                        this.updateData(["provincia"], value)
                                                    }}
                                                >
                                                    {
                                                        definitions.provincia.map(value => {
                                                            return (<Option key={value.value}
                                                                            value={value.value}>{value.name}</Option>)
                                                        })
                                                    }
                                                </Select>
                                            )
                                        }
                                    </Form.Item>
                                </Col>
                                <Col lg={8}>
                                    <Form.Item label="Telefono">
                                        {
                                            getFieldDecorator('telefono', {
                                                value: this.state.formData.telefono,
                                                initialValue: this.state.formData.telefono,

                                            })(
                                                <InputNumber
                                                    style={{width: '100%'}}
                                                    onChange={(e) => this.updateData(["telefono"], [e])}
                                                />
                                            )
                                        }
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={10}>
                                <Col lg={8}>
                                    <Form.Item>
                                        {
                                            getFieldDecorator('active_signup', {
                                                valuePropName: 'checked',
                                                defaultChecked: this.state.formData.active_signup,
                                                initialValue: this.state.formData.active_signup,
                                                value: this.state.formData.active_signup
                                            })(
                                                <Checkbox onChange={() => {
                                                    this.updateData(['active_signup'], [!this.state.formData.active_signup])
                                                    setTimeout(() => this.props.form.validateFields(['code_active']));
                                                }}>
                                                    Habilitar como opcion al registrarse
                                                </Checkbox>
                                            )
                                        }
                                    </Form.Item>
                                    <Form.Item >
                                        {
                                            getFieldDecorator('is_code_active', {
                                                valuePropName: 'checked',
                                                defaultChecked: this.state.formData.is_code_active,
                                                initialValue: this.state.formData.is_code_active,
                                                value: this.state.formData.is_code_active
                                            })(
                                                <Checkbox onChange={() => {
                                                    this.updateData(['is_code_active'], [!this.state.formData.is_code_active])
                                                    setTimeout(() => this.props.form.validateFields(['code_active']));
                                                }}>
                                                    Requerir codigo de activacion
                                                </Checkbox>
                                            )
                                        }
                                    </Form.Item>
                                </Col>
                                <Col lg={8}>
                                    <Form.Item label="Codigo de activacion">
                                        {
                                            getFieldDecorator('code_active', {
                                                value: this.state.formData.code_active,
                                                initialValue: this.state.formData.code_active,
                                                rules: [{
                                                    required: this.state.formData.is_code_active,
                                                    message: "Codigo de activacion requerido"
                                                }]
                                            })(
                                                <Input
                                                    style={{width: '100%'}}
                                                    onChange={(e) => this.updateData(["code_active"], [e.target.value ? e.target.value : null])}
                                                />
                                            )
                                        }
                                    </Form.Item>
                                </Col>
                                <Col lg={8}>
                                    <Form.Item label="Nombre visible">
                                        {
                                            getFieldDecorator('display_name', {
                                                value: this.state.formData.display_name,
                                                initialValue: this.state.formData.display_name
                                            })(
                                                <Input
                                                    onChange={(e) => this.updateData(["display_name"], [e.target.value ? e.target.value : null])}
                                                />
                                            )
                                        }
                                    </Form.Item>
                                </Col>
                            </Row>
                        </>
                }
            ];

            return (
                <BaseAdmin
                    title="Editar admin lite"
                    selected="edit-user-admin-lite"
                >
                    <Card
                        style={{marginBottom: 10}}
                    >
                        <Form hideRequiredMark>
                            <div className="steps-content">{steps[0].content}</div>
                        </Form>
                        <div className="steps-action" style={{marginTop: 20}}>
                            <Button.Group>
                                <Button type="primary" onClick={() => this.save()} loading={this.state.loading}>
                                    Guardar
                                </Button>

                                <Button onClick={() => this.props.history.goBack()} loading={this.state.loading}>
                                    Volver
                                </Button>
                            </Button.Group>
                        </div>
                    </Card>
                </BaseAdmin>
            );
        }

    }
}

const EditUserLiteScreen = Form.create({name: 'invoice'})(withBreakpoints(EditUserLite));

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EditUserLiteScreen));
